<template>
  <div class="ios-preview">
    <div class="ios-preview__date">{{ currentDate }}</div>
    <div class="ios-preview__time">{{ currentTime }}</div>

    <v-row
      no-gutters
      class="ios-preview__notification"
    >
      <v-row
        no-gutters
        style="flex: unset"
        align="center"
      >
        <div class="ios-preview__notification-icon">
          <v-img src="https://s3.timeweb.com/3ac0b538-rosterhit/rh-logo.png" />
        </div>
      </v-row>
      <v-col class="pa-0">
        <div class="ios-preview__notification-header">
          <div class="ios-preview__notification-left">
            <div class="ios-preview__notification-app">{{ processedTitle }}</div>
          </div>
          <div class="ios-preview__notification-time">сейчас</div>
        </div>
        <div
          class="ios-preview__notification-content"
          v-html="processedBody"
        ></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import * as moment from 'moment'
  import { defineComponent } from 'vue'
  import { userNotificationPlaceholders } from '@/services/userNotificationPlaceholders'

  export default defineComponent({
    name: 'PushPreviewIos',
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    computed: {
      currentDate() {
        moment.locale('ru')
        const res = moment().format('dddd, D MMMM')
        return `${res[0].toUpperCase()}${res.slice(1)}`
      },
      currentTime() {
        return moment().format('HH:mm')
      },
      processedBody() {
        let text = this.item.body
        if (!text) return ''
        userNotificationPlaceholders.forEach(placeholder => {
          text = text.replaceAll(placeholder.value, placeholder.exampleValue)
        })
        text = text.replaceAll('\n', '<br>')
        return text
      },
      processedTitle() {
        let text = this.item.title
        if (!text) return ''
        userNotificationPlaceholders.forEach(placeholder => {
          text = text.replaceAll(placeholder.value, placeholder.exampleValue)
        })
        return text
      }
    }
  })
</script>

<style scoped>
  .ios-preview {
    width: 400px;
    min-height: 300px;
    background: linear-gradient(180deg, rgb(255 184 7 / 95%) 0%, rgb(220 107 5) 100%);
    border-radius: 16px;
    padding: 24px;
    color: white;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .ios-preview__date {
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    opacity: 0.9;
  }

  .ios-preview__time {
    text-align: center;
    font-size: 72px;
    font-weight: 300;
    line-height: 1;
    margin-bottom: 32px;
    letter-spacing: -1px;
  }

  .ios-preview__notification {
    background: rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(25px);
    border-radius: 16px;
    padding: 12px 16px;
    box-shadow: 0 4px 12px rgba(139, 69, 19, 0.15);
    gap: 12px;
  }

  .ios-preview__notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ios-preview__notification-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ios-preview__notification-icon {
    width: 30px;
    height: 30px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ios-preview__notification-app {
    font-weight: 600;
    font-size: 15px;
  }

  .ios-preview__notification-time {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.75);
  }

  .ios-preview__notification-content {
    font-size: 15px;
    line-height: 1.3;
    color: rgba(255, 255, 255, 0.95);
  }
</style>
